export default __webpack_public_path__ + "static/media/3.74729346.png";